import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrud = () => import('./staff/crud')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'AccessStaffDashboard',
  crud: 'AccessStaffCrud',
}

const router =
  [
    {
      path: '/st/access',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Accesos',
          }                                  
        },
        {
          path: 'crud',
          name: VIEWS.crud,
          component: ViewStaffCrud,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'ABM accesos',
          }                                  
        }, 
      ]
    },

    {
      path: '/cu/access',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/access',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
